export default __webpack_public_path__ + "679f9bdda6827b8c91f50d840b4e99fa.svg";